(() => {
  const connected = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const connect = video => {
    if (connected.has(video)) return;
    connected.add(video);
    video.controls = false;
    video.defaultMuted = true;
    video.disablePictureInPicture = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('controlslist', 'nodownload noremoteplayback');
    const silence = () => {
      if (!video.muted) video.muted = true;
      if (video.volume !== 0) video.volume = 0;
    };
    silence();
    video.addEventListener('volumechange', silence);
    video.addEventListener('play', silence);
    video.addEventListener('contextmenu', event => event.preventDefault());

    let wrapper = video.parentElement;
    if (!wrapper.matches('[data-silent-player]')) {
      wrapper = document.createElement('div');
      wrapper.className = 'silent-video';
      wrapper.dataset.silentPlayer = '';
      video.before(wrapper);
      wrapper.append(video);
    }
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'silent-video__toggle';
    const icon = document.createElement('span');
    icon.className = 'silent-video__icon';
    icon.setAttribute('aria-hidden', 'true');
    button.append(icon);
    wrapper.append(button);
    const update = () => {
      button.setAttribute('aria-label', video.paused ? 'Play demonstration' : 'Pause demonstration');
      button.classList.toggle('is-playing', !video.paused);
    };
    let wantsPlayback = video.autoplay && !reducedMotion.matches && !navigator.connection?.saveData;
    if (!wantsPlayback) {
      video.autoplay = false;
      video.pause();
    }
    const play = () => {
      silence();
      video.play().catch(update);
    };
    button.addEventListener('click', () => {
      wantsPlayback = video.paused;
      if (wantsPlayback) play(); else video.pause();
    });
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    video.addEventListener('ended', () => {
      if (!video.loop) wantsPlayback = false;
      update();
    });
    update();
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting && wantsPlayback && !document.hidden) play();
          else if (!entry.isIntersecting) video.pause();
        }
      }, { threshold: 0.15 });
      observer.observe(video);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(video)) observer.disconnect();
      });
    }
  };
  const scan = root => {
    if (root.matches?.('video')) connect(root);
    root.querySelectorAll?.('video').forEach(connect);
  };
  scan(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) scan(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();
